import * as Services from "../../../Service/Service";
import * as Url from "../../../Service/Url";

export const GetEruDetails = async () => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_ERU_DETAILS, token);
  return res;
};

export const GetEruDetailsPagination = async (page) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(
    Url.GET_ERUS_PAGINATION + `PageNumber=${page}&PageSize=100`,
    token
  );
  return res;
};

export const GetEruDetailsPaginationBySearch = async (page, search) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(
    Url.GET_ERUS_PAGINATION_SEARCH + `PageNumber=${page}&PageSize=100&Search=${search}`,
    token
  );
  return res;
};

export const GetDataEruByICDCodes = async (ICDCodes) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_ERU_BY_ICDCODES + ICDCodes, token);
  return res;
};

export const addOrUpdateERUs = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.ADD_OR_UPDATE_ERU, payload, token);
  return res;
};

// export const ImportEru = async (payload) => {
//   const token = localStorage.getItem("token");
//   let res = await Services.POST(Url.IMPORT_ERU, payload, token);
//   return res;
// };

export const ImportEru = (payload) => {
  const token = localStorage.getItem("token");

  let res = Services.POSTFORMDATA(
    `/api/ACG_ERU/ImportEru`,
    payload,
    token
  );
  return res;
};
